﻿module Dashboard {

    export interface IDashboardBreadCrumb {
        get(page:string, bk: any): Crumb[];
    }

    export class DashboardBreadCrumb implements IDashboardBreadCrumb{
        private extraCrumbs;
        private bookingTypes;

        constructor(
            private resourceService: Core.ResourceService,
            private unadjustedDateFilter,
            private dashboardBookingService,
            private currentUser,
            private $routeParams) {

            this.extraCrumbs = {
                MYBOOKINGS: {
                    label: this.resourceService.get(
                        this.currentUser.get().HardSignedIn
                            ? 'DASHBOARDRESOURCE_MYBOOKINGS'
                            : 'DASHBOARDRESOURCE_MYBOOKING'),
                    PagePath: this.currentUser.get().HardSignedIn ?
                        'dashboard/bookings/current' : 'dashboard/bookings/reference/{{::BookingId}}'
                },
                RAISECSR: {
                    label: 'DASHBOARDRESOURCE_RAISECSR',
                    PagePath: 'dashboard/create-csr/{{::BookingId}}'
                },
                CSRDETAILS: {
                    label: this.resourceService.get('CSRREF') + ': {{::CsrId}}',
                    PagePath: 'dashboard/csr-details/{{::BookingId}}/{{::CsrId}}'
                },
                SEATSELECTION: {
                    label: this.resourceService.get('SEATSELECTIONBREADCRUMB'),
                    PagePath: 'dashboard/seat-selection/{{::BookingId}}'
                }
            };

            this.bookingTypes = dashboardBookingService.getBookingTypeMap();
        }

        public get(pages, bk) {
            if (bk) {
                let bookingType = this.getBookingTypeText(bk);
                let title = bk.Title ? (bk.Title + ' ') : '';
                this.extraCrumbs['VIEWBOOKINGDETAILS'] = {
                    label: `${title}${bookingType} ${this.unadjustedDateFilter(bk.StartDate, 'dd MMM yyyy')}`,
                    PagePath:  'dashboard/booking-details/{{::BookingId}}'
                };
            }


            let actions =  _.extend(this.dashboardBookingService.getBookingActions(), this.extraCrumbs);
            if (pages) {
                let actionLinks = this.dashboardBookingService.getActionLinks();

                const crumbTrail = pages.split('|').map(page => ({
                    Title: this.dashboardBookingService.translateActionLink(actions[page]
                        && this.resourceService.get(actions[page].label), {
                        BookingId: bk && bk.BookingId,
                        CsrId: this.$routeParams.csrId
                    }),
                    PagePath:
                        this.dashboardBookingService.translateActionLink(actions[page] && actions[page].PagePath
                                || actionLinks[page], {
                            BookingId: bk && bk.BookingId,
                            CsrId: this.$routeParams.csrId
                        })
                })).filter(page => page.PagePath && page.Title);
                return crumbTrail;

            }
            return [];

        }

        getBookingTypeText(bk) : string {
            return _.includes([
                this.bookingTypes.transfer,
                this.bookingTypes.accommodation,
                this.bookingTypes.attraction,
            ], bk.Type) ? '' : this.resourceService.get(bk.LongType.code);
        }
    }

    interface Crumb {
        Title: string;
        PagePath: string;
    }

    angular
        .module('dashboard')
        .service('dashboardBreadCrumbDetails', DashboardBreadCrumb);

}
